import type { Marlin } from './marlin';
import { defineReporter } from '@zg-rentals/monitor-base';
import { task } from 'true-myth';

export default (marlin: Marlin, appName: string, serverName: string) =>
  defineReporter({
    count: (name, amount) =>
      task.tryOrElse(
        (reason) => `marlinReporter counts error: ${reason}`,
        () =>
          marlin.sendCounts({
            serviceName: appName,
            serverName: serverName,
            countStats: {
              [Date.now()]: {
                [name]: { sum: amount },
              },
            },
          }),
      ),

    gauges: (name, amount) =>
      task.tryOrElse(
        (reason) => `marlinReporter gauges error: ${reason}`,
        () =>
          marlin.sendGauges({
            serviceName: appName,
            serverName: serverName,
            gauges: {
              [Date.now()]: {
                [name]: {
                  count: 1,
                  sum: amount,
                  min: amount,
                  max: amount,
                },
              },
            },
          }),
      ),

    measurementWithGauges: (name, amount) =>
      task.tryOrElse(
        (reason) => `marlinReporter measurementWithGauges error: ${reason}`,
        () =>
          marlin.sendMeasurementWithGauges({
            serviceName: appName,
            serverName: serverName,
            measurements: {
              [name]: [{ timeMs: Date.now(), value: amount }],
            },
          }),
      ),
  });
